
export const forgotPasswordMutation = `
  mutation ForgotPasswordMutation($email: String!) {
    ForgotPassword (email: $email) {
      success
    }
  }  
`;
